module.exports = __webpack_public_path__ + "img/symbol_15_normal.4ba8714b.png";